import { render } from "./DahamSchoolView.vue?vue&type=template&id=2be36178&scoped=true"
import script from "./DahamSchoolView.vue?vue&type=script&lang=js"
export * from "./DahamSchoolView.vue?vue&type=script&lang=js"

import "./DahamSchoolView.vue?vue&type=style&index=0&id=2be36178&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be36178"]])

export default __exports__